import styled from 'styled-components';

export const StyledOrdinalNumberCell = styled.div`
   padding-top: 2px;
`;
StyledOrdinalNumberCell.displayName = 'StyledOrdinalNumberCell';
